import { render } from "./PlantEvaluations.vue?vue&type=template&id=66651caa"
import script from "./PlantEvaluations.vue?vue&type=script&lang=js"
export * from "./PlantEvaluations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__